import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../utils/date';
import ResultLink from '../../shared/links/ResultLink';

const Quotes = ({ data: { quotes, lookupTable } }) => (
    <section className="hp-quotes">
        {quotes && quotes.map(({
            raceDate,
            raceId,
            raceTitle,
            courseName,
            courseUid,
            courseStyleName,
            distanceFurlong,
            goingTypeCode,
            rpPostmark,
            notes,
        }) => (
            <div className="hp-quotes__item" key={raceId}>
                <h2 className="hp-quotes__header">
                    <ResultLink
                        className="hp-quotes__resultsLink"
                        courseName={courseName}
                        courseUid={+courseUid}
                        raceInstanceUid={raceId}
                        raceInstanceTitle={raceTitle}
                        raceDatetime={raceDate}
                    >
                        {formatDate(raceDate, 'DMMMYY')}
                    </ResultLink>
                    &nbsp;{courseStyleName}&nbsp;
                    ({distanceFurlong}
                    {lookupTable && lookupTable[goingTypeCode].servicesDesc}
                    {rpPostmark && `, RPR ${rpPostmark}`})
                </h2>
                <p className="hp-quotes__text">{notes}</p>
            </div>
        ))}
    </section>
);

Quotes.propTypes = {
    data: PropTypes.shape({
        quotes: PropTypes.arrayOf(PropTypes.shape({
            raceDate: PropTypes.string,
            raceId: PropTypes.number,
            raceTitle: PropTypes.string,
            courseName: PropTypes.string,
            courseUid: PropTypes.number,
            courseStyleName: PropTypes.string,
            distanceFurlong: PropTypes.number,
            goingTypeCode: PropTypes.string,
            rpPostmark: PropTypes.number,
            notes: PropTypes.string,
        })),
        lookupTable: PropTypes.objectOf(
            PropTypes.shape({
                servicesDesc: PropTypes.string,
            })
        ),
    }).isRequired,
};

export default Quotes;



// WEBPACK FOOTER //
// ./src/js/horse/quotes/Quotes.jsx